<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light">
        <b-form @submit.prevent="load" @keyup.enter="load">
          <b-form-row>
            <lg-form-const-select label="Tipo:" @change='load' cols="12" sm="4" md="2" v-model="form.tipo"
              :options="optionsTipo" :disabled="fromItemBemPermanenteList" />

            <lg-form-const-select label="Situação:" @change='load' cols="12" sm="4" md="2" v-model="form.situacao"
              :options="optionsFilterSituacao" />
            <lg-form-input v-model="form.numero" label="Número:" cols="12" sm="4" md="2" />
            <lg-form-input v-model="form.descricao" label="Título:" cols="12" sm="4" md="6" />
          </b-form-row>
          <b-form-row>
            <b-col cols="12" class="text-right">
              <b-button id="localizarNatureza" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary" @click="load()">
                <div class="btn-size-alinhamento">
                  <b-icon icon="search" />
                </div>
                <b-tooltip target="localizarNatureza" title="Localizar" triggers="hover"></b-tooltip>

              </b-button>
              <b-button v-if="temPrivilegioInclusao()" id="novaNatureza" @click="abrirModalEdit" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary">
                <div class="btn-size-alinhamento">
                  <b-icon scale="1" icon="plus" />
                </div>
                <b-tooltip target="novaNatureza" title="Adicionar novo..." triggers="hover"></b-tooltip>

              </b-button>
            </b-col>
          </b-form-row>
        </b-form>
        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
          :hover="true" @row-dblclicked="naturezaSelect" show-empty>

          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template v-slot:cell(depreciacao)="{ item }">
            <b-button :disabled="!temPrivilegioEdicao()" v-if="item.numero && item.numero.toString().charAt(0) === '4'" :id="'depreciacao-' + item.id"
              class="my-2 mx-2" size="sm" @click="abrirModalDepreciacao(item)" pill variant="danger">
              <b-icon icon="graph-down" />
              <b-tooltip :target="'depreciacao-' + item.id" title="Configurar dados de depreciação"
                triggers="hover"></b-tooltip>
            </b-button>
          </template>
          <template v-slot:cell(editar)="{ item }">
            <b-button :disabled="!temPrivilegioEdicao()" :id="'editar-' + item.id" class="my-2 mx-2" size="sm" pill variant="primary"
              @click="abrirModalEdit(item)">
              <b-icon icon="pencil-square" />
              <b-tooltip :target="'editar-' + item.id" title="Editar..." triggers="hover"></b-tooltip>
            </b-button>
          </template>
          <template v-slot:cell(situacao)="{ item }">
            <b-form-checkbox :disabled="!temPrivilegioEdicao()" v-model="item.situacao" @change="alteraSituacao(item)" name="check-button" switch size="lg"
              :value="1" :unchecked-value="0" />
          </template>
        </b-table>
        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
              totalPage }} -
              {{ total }} registros</b-col>
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
              <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
              </b-form-select>
            </b-col>
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <NaturezaDespesaForm v-if="showModalEdit" @close="cancelar" :isModal="true" :id="id" :empresaNome="nomeEmpresa"
        :codEmpresa="codigoEmpresa" :prefix="updatedPrefix" />
      <ModalConfigurarDepreciacaoForm v-if="showModalDepreciacao" @close="cancelar" :isModal="true" :id="id"
        :prefix="updatedPrefix" />
    </b-card-body>
  </b-card>
</template>

<script>
import API from "@/core/api/index"
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"
import ModalConfigurarDepreciacaoForm from "../../../core/components/Modals/ModalConfigurarDepreciacaoForm.vue"
import NaturezaDespesaForm from "./NaturezaDespesaForm.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"

export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    NaturezaDespesaForm,
    ModalConfigurarDepreciacaoForm,
  },
  data() {
    return {
      showModalEdit: false,
      showModalDepreciacao: false,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      filtro: "",
      codigoEmpresa: this.codEmpresa || null,
      optionsFilterSituacao: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Ativo", value: "1" },
        { key: "filterSituacao", text: "Inativo", value: "0" },
      ],
      optionsTipo: [],
      form: {
        descricao: "",
        situacao: "1",
        tipo: null,
      },
    }
  },
  props: {
    codEmpresa: Number,
    prefix: {
      Array,
      default: () => [],
    },
    fromItemBemPermanenteList: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  async beforeMount() {

    await API.get("/api/natureza-despesa/grupo-produto", { params: { situacao: 1 } }).then((response) => {
      this.optionsTipo = [
        { text: "Todos", value: null },
        ...response.data.content.map((item) => ({
          text: item.descricao,
          value: item.numero,
        }))
      ]
      if (this.fromItemBemPermanenteList) {
        this.form.tipo = "04"
      }
    })
    this.$service = new ResourceService(`/api/natureza-despesa`)
    this.load()
  },
  watch: {
    page() {
      this.load()
    },
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Natureza Despesa"]
    },
    title() {
      return this.updatedPrefix.join(" > ")
    },
    tableFields() {
      return [
        { key: "numeroFmt", label: "Número" },
        { key: "descricao", label: "Título" },
        { key: "vidaUtil", label: "Vida útil" },
        { key: "valorResidual", label: "Valor Residual" },
        { key: "depreciacao", label: "", tdClass: "w-1" },
        { key: "editar", label: "", tdClass: "w-1" },
        { key: "situacao", label: "", tdClass: "w-1" },

      ]
    },
  },
  methods: {
    temPrivilegioEdicao() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

    },
    temPrivilegioInclusao() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);

    },

    abrirModalEdit(item) {
      this.id = item.id
      this.nomeEmpresa = item.razaoSocial
      this.showModalEdit = true
    },
    abrirModalDepreciacao(item) {
      this.id = item.id
      this.showModalDepreciacao = true
    },
    cancelar() {
      this.showModalEdit = false
      this.showModalDepreciacao = false
      this.id = null
      this.nomeEmpresa = ""
      this.codigoEmpresa = null
      this.load()
    },
    async load() {
      this.filtro = ""
      this.filtro = {}
      if (this.form.descricao) {
        this.filtro.descricao = this.form.descricao
      }
      if (this.form.situacao != undefined) {
        this.filtro.situacao = this.form.situacao
      }
      if (this.form.tipo) {
        this.filtro.tipo = this.form.tipo != null ? this.form.tipo.replace(/^0+/, '') : null
      }
      if (this.form.numero) {
        this.filtro.numero = this.form.numero.replace(/[^\d]/g, '')
      }

      this.busy = true

      await this.$loadResource({
        size: this.perPage,
        page: this.page,
        params: this.filtro,
      })
    },
    naturezaSelect(item) {
      this.$emit("onDblClickNaturezaDespesa", item)
    },
    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " +
        (item.situacao === 1 ? "ativar" : "desativar") +
        " o Modelo?",
        item.descricao.toUpperCase()
      )
      if (response == true) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
    },

    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item)
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        })
      }
    },
  },
}
</script>
